export function requiredRule(message = 'This field is required'): (value: string) => boolean|string {
    return (value: string) => !!value || message;
}

export function characterCountRule(field = 'Field', maxCount = 255, minCount = 0): (value: string) => boolean|string {
    return (value: string) => {
        if ((typeof value=='undefined') || (typeof value!='undefined' && value.length >= minCount && value.length <= maxCount)) {
            return true;
        }

        if (minCount != 0) {
            return `${field} must be at least ${minCount} characters and no more than ${maxCount} characters`;
        }

        return `${field} must be no more than ${maxCount} characters`;
    };
}

export function onlyLettersAndNumbersAllowedRule(): (value: string) => boolean|string {    
    return (value: string) => !/[^a-zA-Z0-9]/.test(value) || 'Only letters and numbers are allowed';
}

export function onlyLettersNumbersApostrophesHyphensAndSpacesAllowedRule(): (value: string) => boolean|string {    
    return (value: string) => !/[^a-zA-Z0-9 '-]/.test(value) || 'Only letters, numbers, apostrophes, hyphens and spaces are allowed';
}

export function onlyLettersApostrophesHyphensAndSpacesAllowedRule(): (value: string) => boolean|string {
    return (value: string) => !/[^a-zA-Z '-]/.test(value) || 'Only letters, apostrophes, hyphens and spaces are allowed';
}

export function onlyNumbersAllowedRule(): (value: string) => boolean|string {
    return (value: string) => !/[^0-9]/.test(value) || 'Only numbers are allowed';
}

export function incomeCharacterCountRule(field = 'Field', maxCount = 9): (value: string) => boolean|string {
    return (value: string) => {
        value = value.replace('$', '');
        value = value.split(',').join('');
        if (value.length > maxCount) {
            return `${field} must be no more than ${maxCount} characters`;
        }
        return true;
    }; 
}

export function emailRule(): (value: string) => boolean|string {    
    return (value: string) => {
        if (/.+@.+/.test(value) && /^\S*$/.test(value)) {
            return true;
        }
        return 'Please correct email format';
    }
}

export function stateExclusionRule(message = 'This field is required'): (value: string) => boolean|string {    
    const unsupportedStates = ['AK', 'CA', 'DE', 'HI', 'ID', 'IA',
    'ME', 'MN', 'MT', 'NE', 'NH', 'ND',
    'SC', 'VT', 'DC', 'WI', 'WY']
    return (value: string) => !unsupportedStates.includes(value) || message;
}

export function under18Rule(message = 'You are under 18.'): (value: string) => boolean|string {
    const dt = new Date();
    dt.setUTCHours(0,0,0,0);
	dt.setFullYear(dt.getFullYear() - 18);
    return (value: string) => {
        return dt >= new Date(value) || message;
    }
}

export function under19AlabamaRule(message = 'You are under 19 in Alabama.', birthDate: string): (value: string) => boolean|string {
    return (value: string) => {
        const dt = new Date();
        dt.setFullYear(dt.getFullYear() - 19);
        dt.setUTCHours(0,0,0,0);
        if ((value == 'AL' && dt.toISOString().substr(0, 10) < birthDate)) {
            return message;
        }
        return true;
    };
}

export function notDateInFuture(message = 'Must be a date in the past'): (value: string) => boolean|string {
    return (value: string) => {
        const dt = new Date();
        dt.setUTCHours(0,0,0,0);
        const inputDate = new Date(value);
        return dt >= inputDate || message;
    } 
}

export function notDateInPast(message = 'Must be a date in the future'): (value: string) => boolean|string {
    return (value: string) => {
        const dt = new Date();
        const inputDate = new Date(value);
        dt.setUTCHours(0,0,0,0);
        return dt <= inputDate || message;
    } 
}

export function usCitizenRule(message = 'We\'re sorry. We are unable to originate your account online at this time.'): (value: string) => boolean|string {
    return (value: string) => value == 'no' ? message : true;
}

export function pepRule(message = 'We\'re sorry. We are unable to originate your account online at this time.'): (value: string) => boolean|string {
    return (value: string) => value == 'yes' ? message : true;
}
